<template>
  <KwDropdown
    :show="show"
    @close="() => show = false"
    align-right
    width-auto
    class="ml_xxl"
  >
    <div
      class="d-flex align-items-center"
      slot='toggle'
      @click="() => show = !show"
    >
      <KwSvgicon
        name='account'
        :width='24'
        :height='24'
      />
      <span class="ml_md mr_sm" v-if="profile.firstname">{{ clientName }}</span>
      <KwSvgiconLocal
        class="account__chevron"
        name='chevron'
      />
    </div>
    <slot name="menu">
      <ul class="dropdown-menu">
        <li
          class="dropdown-menu__item"
          @click="onMenuSelect('bookings')"
        >
          {{ i18n('my_bookings_menu__button') }}
        </li>
        <li
          class="dropdown-menu__item"
          @click="onMenuSelect('extraPayments')"
        >
          {{ i18n('my_extra_payments_menu__button') }}
        </li>
        <li
          class="dropdown-menu__item"
          @click="onMenuSelect('profile')"
        >
          {{ i18n('my_profile_menu__button') }}
        </li>
        <li
          class="dropdown-menu__item"
          @click="onMenuSelect('balance')"
        >
          {{ i18n('my_balance_menu__button') }}
        </li>
        <li class="dropdown-menu__item danger" @click="logOut">
          {{ i18n('log_out_menu__button') }}
        </li>
      </ul>
    </slot>
  </KwDropdown>
</template>

<script>
import KwSvgiconLocal from '@/components/UI/Svgicon.vue';
import KwSvgicon from '@kiwitaxi/vue-components/dist/KwSvgicon';
import KwDropdown from '@kiwitaxi/vue-components/dist/KwDropdown';
import { i18n, locations } from '@/mixins';
import { LOGOUT } from '@/services/AuthService';

export default {
  name: 'Menu',
  mixins: [i18n, locations],
  components: {
    KwSvgicon,
    KwDropdown,
    KwSvgiconLocal,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    profile() {
      return this.$store.getters['$_user/profile'];
    },
    clientName() {
      const [f, s = ''] = this.profile.firstname
        .split(' ')
        .slice(0, 2);
      return `${f} ${s[0] ? s[0].toUpperCase() : ''}`;
    },
  },
  methods: {
    logOut() {
      if (window.IntercomBootstrap) window.IntercomBootstrap.reset();
      if (window.TalkMeBootstrap) window.TalkMeBootstrap.reset();
      this.locationReplace(LOGOUT);
    },
    onMenuSelect(path) {
      this.$router.push({ name: path });
      this.show = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Header/components/Menu.vue